import React, { Suspense, lazy } from 'react';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
const VideoProofSection = lazy(() => import('./components/VideoProofSection').then(module => ({
  default: module.VideoProofSection
})));
const BenefitsSection = lazy(() => import('./components/BenefitsSection').then(module => ({
  default: module.BenefitsSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(module => ({
  default: module.PricingSection
})));
const PreviewGallerySection = lazy(() => import('./components/PreviewGallerySection').then(module => ({
  default: module.PreviewGallerySection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(module => ({
  default: module.FAQSection
})));
export function App() {
  return <div className="min-h-screen bg-[#FFFAF7] font-sans" data-id="element-0">
      <TopBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <Suspense fallback={<div className="h-32" data-id="element-5" />} data-id="element-4">
          <VideoProofSection data-id="element-6" />
          <BenefitsSection data-id="element-7" />
          <PricingSection data-id="element-8" />
          <PreviewGallerySection data-id="element-9" />
          <FAQSection data-id="element-10" />
        </Suspense>
      </main>
      <footer className="bg-[#2D2D3F] text-white py-6 text-center text-sm opacity-90" data-id="element-11">
        <p data-id="element-12">
          © {new Date().getFullYear()} Mega Pack Disney. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}